<template>
    <div class="cpt-tree-wrap">
        <t-loading text="加载中..." size="small" v-if="loading"></t-loading>
        <t-tree :ref="registerRef" v-model="allChecked" :data="list" v-else :expand-all="option.attribute.expandAll"
            :transition="option.attribute.transition" :icon="option.attribute.showIcon"
            :line="option.attribute.showLine" :activable="option.attribute.activable" :maxHeight="current.cptHeight"
            :active-multiple="option.attribute.activeMultiple"
            :expand-on-click-node="option.attribute.expandOnClickNode" :checkStrictly="!option.attribute.checkStrictly"
            :checkable="option.attribute.checkable" :allow-fold-node-on-filter="option.attribute.filter"
            :filter="filterValue" :draggable="option.attribute.draggable"
            :style="{ ...activableStyle(), '---backgroundColor': option.attribute.backgroundColor, '---scrollBgColor': option.attribute.scrollBgColor, '---scrollColor': option.attribute.scrollColor, '---scrollWidth': (option.attribute.scrollWidth || 4) + 'px' }"
            :expand-mutex="option.attribute.mutex" :load="load" @change="onChange" :defaultValue="defaultValue">
            <template #icon="{ node }" v-if="option.attribute.isOpenImage">
                <img :class="{ 'icon-image': true, 'tree-icon-parent': !option.attribute['parentImageUrl'] }"
                    v-if="node.getChildren() && !node.expanded" :src="iconHandler('parentImageUrl')" alt="">
                <icon v-else-if="node.getChildren() && node.expanded && node.loading" name="loading" />
                <img :class="{ 'icon-image': true, 'tree-icon-expanded': !option.attribute['parentImageUrl'] }"
                    v-else-if="node.getChildren() && node.expanded" :src="iconHandler('parentImageUrl')" alt="">
                <template v-else>
                    <img class="icon-image" v-if="iconHandler('childrenImageUrl')"
                        :src="iconHandler('childrenImageUrl')" alt="">
                </template>
            </template>
            <template #label="{ node }">
                <span :style="nodeItemStyle(node)" @click="onClick($event, node)">{{ node.label }}</span>
            </template>
            <template #empty>
                <div class="tree-empty" :style="emptyStyles()">{{ option.attribute.emptyText }}</div>
            </template>
        </t-tree>
    </div>
</template>

<script>
import { ref, onMounted, reactive, inject, watch, onBeforeUnmount, computed } from 'vue'
import { getDataJson, pollingRefresh, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
import options from '@/components/options'
import { fileUrl } from '/env'
// import { mixinsCom } from "@/mixins/globalAllComps";
import { getCurrentInstance } from 'vue';

export default {
    name: "cpt-tree",
    props: {
        option: Object,
        cacheComponents: Array,
        current: Object,
        components: Array
    },
    // mixins: [mixinsCom], 
    setup(props, context) {
        let instance = getCurrentInstance();
        let _this = instance.proxy;
        const drop = inject('drop')
        const option = reactive(props.option)
        const elementRef = ref({})
        let allChecked = ref([])
        let list = ref([])
        let loading = ref(false)
        let uuid = ref(require('uuid').v1())
        let newData = ref("")
        let jsFunFlag = ref(false)
        let treeValue = ref('')
        let curVal = ref('')
        let defaultValue = ref([])
        let filterValue = ref('')
        let dataReload = computed(() => option.attribute.globalDataReload)
        watch(() => props.current.cptShow, (val) => {
            if (val && dataReload.value.includes(1)) {
                refreshCptData();
            }
        })
        watch(() => props.option.attribute.hideCompInTabw, (val) => {
            if (!val && dataReload.value.includes(1)) {
                refreshCptData();
            }
        })
        onMounted(() => {
            console.log(props.option)
            console.log(options)
            // if(option.cptDataForm.dataSource == '1'){
            //     console.log(option.cptDataForm.dataText, 'drop')
            //     option.cptDataForm.resData = JSON.parse(option.cptDataForm.dataText)
            // }
            console.log(dataReload.value, '346534t43')
            if (dataReload.value && dataReload.value.includes(0)) {
                refreshCptData();
            }
        })
        onBeforeUnmount(() => {
            if (props.option.attribute.filter) {
                deleteFilterInput()
            }
        })

        const registerRef = (el) => elementRef.value = el;

        const refreshCptData = (cptDataForm = props.option.cptDataForm, paras) => {
            loading.value = true
            pollingRefresh(uuid.value, cptDataForm, () => loadData(cptDataForm, paras), props.components)
        }
        const loadData = (cptDataForm, paras) => {
            getDataJson(cptDataForm, paras, (res) => {
                loading.value = false
                newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
                setTimeout(() => {
                    // 默认全选
                    if (option.attribute.initChecked) {
                        checkedAll(option.attribute.initChecked)
                    }
                    console.log(option.attribute, paras, 'option.attribute');
                    if (option.attribute['isDefault']) {
                        let value = paras?.value || ''
                        setDefaultValue(value)
                    }
                }, 10)
                // _this.jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
                processData(cptDataForm, newData, jsFunFlag)  //监听里面会执行的
                // tableData = res.list
                // console.log(res, 'asdk,adsakds')
            })
        }


        const processData = (cptDataForm, res, jsFunFlag) => {
            console.log(res, 'treeeeeeee')

            // 第一层判断 如果选择数据集
            if (cptDataForm.dataSource == '4') {
                // 第二层判断 ，如果没有配转换脚本
                // if (hasNonEmptyValues(props.option.attribute.cptTableData)) {
                const dataKey = props.option.attribute.cptTableData;
                // 初始化结果数组和字典
                let newarr = { list: [] };
                let dict = {}; // 用于快速查找父节点
                const dataKeyMap = dataKey.reduce((acc, curr) => {
                    acc[curr.namekey] = curr.value;
                    return acc;
                }, {});

                newarr = listToTree(res, dataKeyMap)
                console.log(newarr, 'newarr');
                list.value = newarr
            } else { // 如果配置了转换脚本
                list.value = res?.list
            }

            console.log(list.value, 'qwdokijwqiojdiwq')

        }
        function findObjectById(arr, idToFind) {
            // 遍历数组中的每个对象
            for (let obj of arr) {
                // 检查当前对象的 id 是否与传入的 idToFind 匹配
                if (obj.ID === idToFind) {
                    return obj; // 如果匹配成功，返回当前对象
                }
                // 如果当前对象有 children 属性，并且是一个数组，递归调用自身查找子节点
                if (Array.isArray(obj.children)) {
                    let found = findObjectById(obj.children, idToFind);
                    if (found) {
                        return found; // 如果在子节点中找到了匹配的对象，则返回该对象
                    }
                }
            }
            return false; // 如果整个数组都没有找到匹配的对象，则返回 false
        }
        const setDefaultValue = (value) => {
            const result = findObjectById(list.value, value)
            console.log(result.children, 'qwdqwdqddq');
            let childrenItem = result.children ? result.children[0] : result
            if (result) onClick(false, { data: childrenItem, value: childrenItem.ID })
        }

        const checkedAll = (val = option.attribute.initChecked) => {
            if (val) {
                let arr = newData
                if (arr.length > 0) {
                    let ids = [];
                    let forArr = (arr) => {
                        arr.forEach((item, index) => {
                            let id = item.value || item.value || item.ID || item.id
                            ids.push(id)
                            item.children ? forArr(item.children) : null;
                        })
                    }
                    forArr(arr);
                    allChecked.value = ids;
                    treeValue.value = ids;
                    setTimeout(() => {
                        context.emit("clickHandler", option.interaction, ids, ids, "cpt-tree");

                    }, 300)
                }
            } else {
                setTimeout(() => {
                    allChecked.value = [];
                    context.emit("clickHandler", option.interaction, [], [], "cpt-tree");
                }, 300)
            }

        }




        const listToTree = (data, dataKeyMap) => {
            console.log(dataKeyMap, 'dataKeyMapdataKeyMap')
            let result = []
            if (!Array.isArray(data)) {
                return result
            }
            data.forEach(item => {
                delete item.children;
            });
            let map = {};
            data.forEach(item => {
                item.value = item[dataKeyMap['value']];
                item.label = item[dataKeyMap['label']];
                map[item[dataKeyMap['value']]] = item;
            });
            console.log(dataKeyMap, 'dataKeyMap');
            data.forEach(item => {
                if (dataKeyMap['child']) {
                    let parent = map[item[dataKeyMap['child']]];
                    if (parent) {
                        (parent.children || (parent.children = [])).push(item);
                    } else {
                        result.push(item);
                    }
                } else {
                    result.push(item);
                }

            });
            return result;
        }

        const deepClone = (obj) => {
            let clone = Object.assign({}, obj);
            if (clone.children) {
                clone.children = clone.children.map(deepClone);
            }
            return clone;

        }
        // 设置默认样式
        const nodeItemStyle = (node) => {
            const { fontSize, fontColor, activableFontSize, activableFontColor, fontLineHeight, activable, checkable, textFamily } = props.option.attribute

            let styles = {
                fontSize: '',
                lineHeight: '',
                color: '',
            }

            styles['fontSize'] = (((node.actived && activable) || (checkable && node.checked) || node.value == curVal.value) ? activableFontSize : fontSize) + 'px'
            styles['color'] = ((node.actived && activable) || (checkable && node.checked) || node.value == curVal.value) ? activableFontColor : fontColor
            styles['lineHeight'] = fontSize + fontLineHeight + 'px'
            styles['display'] = 'inline-block'
            styles['font-family'] = textFamily

            return styles
        }
        const activableStyle = () => {
            const { checkableBgColorAll, checakableBorderAll, activableBgColor, checkableBgColor, checkableColor, checkableStyle, fontSize, fontLineHeight, lineColor, activable } = props.option.attribute
            if (!activable) {
                return {}
            }
            return {
                '---activableBgColor': activableBgColor,
                '---checkableBgColor': checkableBgColor,
                '---checkableColor': checkableColor,
                '---checkableStyle': checkableStyle === 'default' ? '3px' : '50px',
                '---checkableBgColorAll': checkableBgColorAll,
                '---checakableBorderAll': checakableBorderAll,
                '--td-border-level-1-color': lineColor,
                '--color': lineColor,
                '---lineHeight': (fontSize + fontLineHeight) + 'px'
            }
        }
        const emptyStyles = () => {
            const { emptyPosition, emptyColor, emptyFontSize } = props.option.attribute

            return {
                '---emptyColor': emptyColor,
                '---emptyFontSize': emptyFontSize + 'px',
                '---emptyPosition': emptyPosition,
            }
        }
        const iconHandler = computed(() => (type) => {
            let paramsImg = option.attribute[type]
            let defualtImg = require('@/assets/icon/select.svg')
            if (type == 'parentImageUrl') {
                return paramsImg ? fileUrl + paramsImg : defualtImg
            } else if (type == 'childrenImageUrl') {
                return paramsImg ? fileUrl + paramsImg : false
            }
        })

        // 反选
        const onSelectInvert = () => {
            selectHandler((item, revertSelection) => {
                if (!item.checked && !item.indeterminate) {
                    // checked 为 true, 为直接选中状态
                    // indeterminate 为 true, 为半选状态
                    revertSelection.push(item.value);
                }
            }, array => onChange(array))
        }
        // 全选
        const onAllSelect = () => {
            selectHandler((item, revertSelection) => {
                revertSelection.push(item.value);
            }, (array) => onChange(array))
        }
        //
        const selectHandler = (callback, success) => {
            const { getItems } = elementRef.value
            // 取得所有节点
            const items = getItems();
            const revertSelection = [];
            items.forEach((item) => {
                callback && callback(item, revertSelection)
            });
            allChecked.value = revertSelection

            success && success(revertSelection)
        }



        watch(() => props.option.attribute, (obj) => {
            processData(props.option.cptDataForm, newData, jsFunFlag)
        }, { deep: true })
        watch(() => props.option.attribute.filter, value => {
            createFilterInput(value)
        }, { deep: true })
        // 过滤
        const onFilter = () => {
            props.option.attribute.filterValue = (node) => node.data.label.indexOf(filterValue.value) >= 0;
        };

        // 创建过滤输入框
        const createFilterInput = (value) => {
            if (value) {
                let cptInput = find(options, 'cpt-input')
                if (!props.current) {
                    return
                }

                cptInput.cptCompTableChildX = props.current.cptX
                cptInput.cptCompTableChildY = props.current.cptY - cptInput.height
                cptInput.option.attribute.label = '过滤：'
                cptInput.option.attribute.parentId = props.current.id
                drop({
                    type: 'HANLERDROP',
                    handler: cptInput
                })
            } else {
                let findFilterInput = props.cacheComponents.findIndex(x => {
                    let parentId = x.cptOption.attribute?.parentId
                    return parentId == props.current.id
                })
                if (findFilterInput == -1) {
                    return
                }
                props.cacheComponents.splice(findFilterInput, 1)
                filterValue.value = null
            }
        }
        // 删除过滤输入框
        const deleteFilterInput = () => {
            const filterInputIndex = props.cacheComponents.findIndex(x => {
                let isKey = x.cptKey === 'cpt-input'
                let isId = x.cptOption.attribute?.parentId == props.current?.id
                return isKey && isId
            })
            if (filterInputIndex == -1) {
                return
            }
            props.cacheComponents.splice(filterInputIndex, 1)
        }
        const find = (array, key) => {
            for (let i = 0; i < array.length; i++) {
                if (array[i]?.cptKey === key) {
                    return array[i];
                }
                if (array[i]?.children) {
                    let result = find(array[i].children, key);
                    if (result) {
                        return result;
                    }
                }
            }
            return null;
        }
        /**
         * @title 获取子级组件参数的方法
         * @param {子组件调用当前组件的方法传的参数} value 
         */
        const getComponentParams = (value) => {
            filterValue.value = (node) => node.data.label.indexOf(value) >= 0;
        }

        const onClick = (e, value) => {
            console.log('onClick', e, value)
            if (e) e.preventDefault();
            if (option.attribute.isFatherClick && value.data.children?.length) {
                return
            }
            let val = [value.data.value]
            treeValue.value = val
            curVal.value = value.data.value
            console.log(val, context, 'dkjmdkdk')
            option.interaction.checkable = option.attribute.mapPoint || false;

            let eventList = option.interaction.eventList
            for (let i = 0; i < eventList.length; i++) {
                const event = eventList[i];

                // 兼容以前的书控件
                // let isEventHandler = event.hasOwnProperty('eventHandler')
                // console.log(!isEventHandler ,event.eventHandler,'qdkjqw90ij90qiwdj0wqdji80qdiw');
                // if ((event.eventHandler == 'click_event' || event.eventHandler == 'all_event') || !isEventHandler) {
                // }
                context.emit("clickHandler", option.interaction, val, val, "cpt-tree", value, props.current, { eventHandlerType: 'click_event' });
            }

        }
        const onChange = (checked) => {
            // if (checked.length == 0) {
            //     return
            // }
            let val = checked
            console.log('onChange', option, val, context)
            treeValue.value = val

            let eventList = option.interaction.eventList
            for (let i = 0; i < eventList.length; i++) {
                const event = eventList[i];

                // 兼容以前的书控件
                // let isEventHandler = event.hasOwnProperty('eventHandler')
                // if (event.eventHandler == "checked_event" || event.eventHandler == 'all_event' || !isEventHandler) {
                // }
                context.emit("clickHandler", option.interaction, val, val, "cpt-tree", checked, props.current, { eventHandlerType: 'checked_event' });
            }
        }

        const getValue = () => {
            return treeValue.value
        }

        // 查找属性
        const findInTree = (tree, key, value) => {
            // 如果当前节点的属性值匹配，则返回当前节点
            if (tree[key] === value) {
                return tree;
            }
            // 如果当前节点有子节点，递归查找子节点
            if (tree.children && Array.isArray(tree.children)) {
                for (let child of tree.children) {
                    // 递归调用自身，查找子节点
                    let result = findInTree(child, key, value);
                    if (result) {
                        // 如果找到匹配的属性，返回结果
                        return result;
                    }
                }
            }
            // 如果没有找到匹配的属性，返回null
            return null;
        }


        return {
            list,
            uuid,
            filterValue,
            option,
            iconHandler,
            treeValue,
            loading,
            allChecked,
            refreshCptData,
            processData,
            loadData,
            nodeItemStyle,
            activableStyle,
            emptyStyles,
            onFilter,
            getComponentParams,
            registerRef,
            onClick,
            onChange,
            onSelectInvert,
            onAllSelect,
            getValue,
            findInTree,
            checkedAll
        }
    }


}
</script>


<style>
.t-tree::-webkit-scrollbar-thumb {
    background: var(---scrollColor);
}

.t-tree::-webkit-scrollbar-track {
    background: var(---scrollBgColor);
}

.t-tree::-webkit-scrollbar {
    width: var(---scrollWidth);
}

.cpt-tree-wrap .t-tree .t-is-active,
.cpt-tree-wrap .t-tree .t-tree__item .t-is-checked {
    background: var(---activableBgColor) !important;
}

.cpt-tree-wrap .t-tree__label {
    background: var(---backgroundColor);
}

.cpt-tree-wrap .t-checkbox .t-checkbox__input {
    background: var(---checkableBgColorAll);
    border: 1px solid var(---checakableBorderAll);
}

.cpt-tree-wrap .t-checkbox.t-is-checked .t-checkbox__input,
.cpt-tree-wrap .t-checkbox.t-is-indeterminate .t-checkbox__input {
    border-color: var(---checkableBgColor) !important;
    background-color: var(---checkableBgColor) !important;
    border-radius: var(---checkableStyle);
}

.cpt-tree-wrap .t-checkbox.t-is-checked .t-checkbox__input::after {
    border-color: var(---checkableColor) !important;
}

.cpt-tree-wrap .t-checkbox.t-is-indeterminate .t-checkbox__input::after {
    background-color: var(---checkableColor) !important;
}

.cpt-tree-wrap .t-checkbox .t-checkbox__input {
    border-radius: var(---checkableStyle);
}

.cpt-tree-wrap .t-tree__line {
    height: calc(var(---lineHeight) + 4px) !important;
    bottom: calc(var(---lineHeight) / 2) !important;
    margin-left: -1px;
}

.cpt-tree-wrap .t-tree__line::before {
    height: calc(var(---lineHeight) + 3px) !important;
}

.cpt-tree-wrap .tree-empty {
    display: flex;
    align-items: center;
    justify-content: var(---emptyPosition);
    color: var(---emptyColor);
    font-size: var(---emptyFontSize);

}

.cpt-tree-wrap .icon-image {
    width: 100%;
    height: 100%;
    transition: .6s ease-in-out;

}

.cpt-tree-wrap .tree-icon-parent {
    transform: scale(0.7);
}

.cpt-tree-wrap .tree-icon-expanded {
    transform: rotate(90deg) scale(0.7);
}

/* .cpt-tree-wrap .t-tree__empty {
    min-height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
}  */
</style>